import React from 'react';
import { AppLayout } from '../components/layout/AppLayout';
import { ClinicInfoList } from '../components/features/ClinicInfoList';

interface ClinicPageProps {
  initialTab?: number;
}

export const ClinicPage: React.FC<ClinicPageProps> = ({ initialTab = 0 }) => {
  return (
    <AppLayout title="О клинике">
      <ClinicInfoList />
    </AppLayout>
  );
};
